import React from "react";
import ContactUs from "../../Componenets/ContactPage/ContactUs";

import { Box } from "@mui/material";
import Faq from "../../Componenets/ContactFaq/Faq";
import ContactForm from "../../Componenets/ConatctForm/ContactForm";

function OurContact() {
  return (
<Box>
  <ContactUs />
  <Faq />
  <ContactForm />
    </Box>
  );
}

export default OurContact;
